import React, { useEffect } from "react";
import PublicLayout from "../../components/PublicLayout";
import EventsManifesto from "../../components/landing/home2/EventsManifesto";
import CreationStrategy from "../../components/landing/home2/CreationStrategy";
import ProductionLayers from "../../components/landing/home2/ProductionLayers";
import CommercialPlatform from "../../components/landing/home2/CommercialPlatform";
import BrandActivation from "../../components/landing/home2/BrandActivation";
import MediaEngine from "../../components/landing/home2/MediaEngine";
import EventTechnology from "../../components/landing/home2/EventTechnology";
import EventConsulting from "../../components/landing/home2/EventConsulting";
import EventsCredentials from "../../components/landing/home2/EventsCredentials";
import { SITE } from "../../content/site";
import { routePath } from "../../lib/routes";
import { track, EVENTS } from "../../lib/analytics";

export default function EventsCapabilities({ lang }) {
  const c = (SITE[lang].capabilities || SITE.en.capabilities);
  const alt = (SITE[lang].events || SITE.en.events).alt;
  useEffect(() => { window.scrollTo(0, 0); track(EVENTS.PAGE_VIEW, { page: "events_capabilities", lang }); }, [lang]);

  return (
    <PublicLayout pageKey="eventsCapabilities" lang={lang} overlayNav
      crumbs={[
        { name: SITE[lang].breadcrumbs.events, path: routePath("events", lang) },
        { name: (SITE[lang].nav.capabilities || SITE.en.nav.capabilities), path: routePath("eventsCapabilities", lang) },
      ]}>
      <div data-testid="capabilities-page">
        <section className="relative overflow-hidden bg-white" data-testid="capabilities-hero">
          <div className="relative h-[86vh] min-h-[620px] md:h-[104vh]">
            <img src="/events/hero.jpg" alt={alt.hero} width="1920" height="1245" fetchPriority="high"
              className="absolute inset-0 h-full w-full object-cover object-top" />
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(115%_85%_at_0%_60%,rgba(5,5,5,0.62)_0%,rgba(5,5,5,0.28)_40%,transparent_66%)]" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[32%] bg-gradient-to-b from-transparent via-white/70 to-white" />
            <div className="relative z-10 mx-auto flex h-full max-w-[1400px] flex-col justify-end px-6 pb-[32vh] md:px-12 md:pb-[36vh]">
              <p className="overline text-white/70 [text-shadow:0_1px_16px_rgba(0,0,0,0.5)]">{c.overline}</p>
              <h1 className="font-display mt-5 max-w-4xl text-4xl font-light leading-[1.02] tracking-tightest text-white [text-shadow:0_2px_28px_rgba(0,0,0,0.5)] sm:text-5xl lg:text-6xl">{c.title}</h1>
              <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-white/85 [text-shadow:0_1px_18px_rgba(0,0,0,0.55)] md:text-lg">{c.sub}</p>
            </div>
          </div>
        </section>
        <EventsManifesto />
        <CreationStrategy />
        <ProductionLayers />
        <CommercialPlatform />
        <BrandActivation />
        <MediaEngine />
        <EventTechnology />
        <EventConsulting />
        <EventsCredentials />
      </div>
    </PublicLayout>
  );
}
